<template>
    <div class="catalogue">
        <template v-if="page">
            <!-- current page -->
            <transition name="fade" mode="out-in">
                <component :is="page.component" :slug="slug"></component>
            </transition>

            <!-- nav arrows -->
            <button
                v-if="has_previous_page"
                :style="{
                    backgroundImage: 'url(images/commons/btnArrowPrevious.png)'
                }"
                class="arrow-previous fixed top-1/2 left-2 w-8 md:w-12 lg:w-8 2xl:w-14 h-8 md:h-12 lg:h-8 2xl:h-14 bg-center bg-no-repeat bg-contain"
                @click="gotoPreviousPage()"
            >
                <i class="icon-chevron-left"></i>
                <!-- <span v-show="$route.fullPath === '/catalogue/page-002'" class="addTextPage2"></span> -->
               
            </button>

            <button
                v-if="has_next_page"
                :style="{
                    backgroundImage: 'url(images/commons/btnArrowNext.png)'
                }"
                class="arrow-next  fixed top-1/2 right-2 w-8 md:w-12 lg:w-8 2xl:w-14 h-8 md:h-12 lg:h-8 2xl:h-14 bg-center bg-no-repeat bg-contain"
                @click="gotoNextPage()"
            >
                <i class="icon-chevron-right"></i>
            </button>
        </template>



        <modal-richmedia :options="{
            pages,
            page
        }"/>
    </div>
</template>

<script>
    export default {
        name: 'Catalogue',
        props: {
            slug: null
        },
        data() {
            return {};
        },
        computed: {
            pages() {
                let vm = this;
                return this.$t('pages');
            },
            config() {
                let vm = this;
                return this.$t('config');
            },
            page() {
                return this.pages.getBySlug(this.slug);
            },

            has_previous_page() {
                let orderd_pages = this.getOrderedPages();
                return orderd_pages.previous !== null;
            },
            has_next_page() {
                let orderd_pages = this.getOrderedPages();
                return orderd_pages.next !== null;
            },
            
        },
        methods: {

            handlerKeyUp(e){
                let vm = this;
                
                if(e.key === 'ArrowRight'){
                    vm.gotoNextPage();
                } else if(e.key === 'ArrowLeft'){
                    vm.gotoPreviousPage();
                }
            },

            initComponentsForPages() {
                let pages = this.$t('pages').getAll();
                pages.forEach((page) => {
                    let component_name = page.component || 'PageDefault';
                    Vue.component(component_name, require(`@/views/pages/${component_name}.vue`).default);
                });
            },

            getOrderedPages() {
                let vm = this;
                //

                let first_page = null;
                let last_page = null;

                let previous_page = null;
                let current_page = null;
                let next_page = null;

                //

                let pages = vm.pages.getAll();
                if (pages.length) {
                    for (let i = 0; i < pages.length; i++) {
                        let page = pages[i];
                        //
                        if (!first_page) {
                            first_page = page;
                        }
                        //
                        last_page = page;
                        //
                        if (!current_page && page.slug === vm.page.slug) {
                            current_page = page;
                        }
                        if (!current_page) {
                            previous_page = page;
                        }
                        if (!next_page && current_page && current_page.slug !== page.slug) {
                            next_page = page;
                        }
                    }
                }

                //
                switch (vm.config.catalogue.loop) {
                    case 'infinite-previous':
                        if (current_page === first_page && !previous_page) {
                            previous_page = last_page;
                        }
                        break;
                    case 'infinite-next':
                        if (current_page === last_page && !next_page) {
                            next_page = first_page;
                        }
                        break;
                    case 'infinite':
                        if (current_page === first_page && !previous_page) {
                            previous_page = last_page;
                        }
                        if (current_page === last_page && !next_page) {
                            next_page = first_page;
                        }
                        break;
                    case 'none':
                    default:
                        break;
                }

                //

                return {
                    first: first_page,
                    last: last_page,
                    previous: previous_page,
                    current: current_page,
                    next: next_page
                };
            },

            gotoPreviousPage() {
                let vm = this;
                let orderd_pages = vm.getOrderedPages();
                let previous_page = orderd_pages.previous;
                if (previous_page) {
                    // console.log('previous_page', previous_page);
                    vm.$router.push({ name: 'catalogue', params: { slug: previous_page.slug } });
                }
            },
            gotoNextPage() {
                let vm = this;
                let orderd_pages = vm.getOrderedPages();
                let next_page = orderd_pages.next;
                if (next_page) {
                    // console.log('next_page', next_page);
                    vm.$router.push({ name: 'catalogue', params: { slug: next_page.slug } });
                }
            }
        },
        created() {
            this.initComponentsForPages();

        },
        mounted() {
            let vm = this;

            if (!this.page) {
                this.$router
                    .push({
                        name: 'summary'
                    })
                    .catch(() => {});
            }

            window.addEventListener('keyup', vm.handlerKeyUp);

        },
        beforeDestroy() {
            let vm = this;
            window.removeEventListener('keyup', vm.handlerKeyUp);
        }
    };
</script>

<style scoped lang="scss">
    .catalogue {
        position: relative;
        // overflow-x: hidden;
        min-height: 100vh;

        ::v-deep .page {
            // @apply bg-yellow-50;

            .container {
                // @apply bg-red-50;
                // min-height: calc(100vh - var(--header_height) - var(--header_space));
                // margin-top: calc(var(--header_height) + var(--header_space));
            }
        }
    }

    /**/
    .fade-enter-active {
        transition: all 0.3s ease-in-out;
    }

    .fade-leave-active {
        transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .fade-enter, .fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
        /*transform: translateX(10px);*/
        opacity: 0;
    }
    .addTextPage2{
        &::after{
            content:"Voir la préface et l'avant propos";
            position: absolute;
            top: 115%;
            left: 0%;
            font-family: "Frenchute";
            overflow: overlay;
            color: #fff;
            font-weight: 700;
            background-color: #00548B;
            padding: 3px 7px;
            font-size: 14px;
            width: 120px;
            @media screen and (min-width:768px) {
                font-size: 18px;
                width: 200px;
            }
        }
    }
</style>
